import React, { useState, useEffect, useRef } from "react";
import { fetchOpenTickets, fetchOpenTicketsNew } from "@services/api";
import { useNavigation, useIsFocused } from "@react-navigation/native";
import {
  View,
  FlatList,
  TouchableNativeFeedback,
  TouchableWithoutFeedback,
  StyleSheet,
  Pressable,
} from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import Text from "@components/CustomText";
import t from "@constants/localization";
import Loader from "../components/CoverLoader";
import TicketsList from "./TicketsList";
import CancelOrReopenDialog from "./CancelOrReopenDialog";
import cancelSupportTicket from "../utils/cancelSupportTicket";
import colors from "@constants/color";
import { fontFamily } from "@utils/styles";

const PATH = "screens/SupportTree/SupportTickets/index";

const AllTickets = () => {
  const navigation = useNavigation();
  const [tickets, setTickets] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // const statusList = ["सभी", ...Object.values(statusMap)];

  const [cancelTicketid, setCancelTicketId] = useState(null);
  const [issueLevel1, setIssueLevel1] = useState(null);
  const [reopenId, setReopenId] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showReopenModal, setShowReopenModal] = useState(false);

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const scrollRef = useRef();
  const focused = useIsFocused();
  const [fetchMore, setFetchMore] = useState(false);
  const [totalTicketCount, setTotalTicketCount] = useState(0);
  const [endReached, setEndReached] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);

  const statusList = [
    t(`${PATH}/all`),
    t(`${PATH}/processing`),
    t(`${PATH}/solved`),
    t(`${PATH}/cancelled`),
  ];

  const statusListEn = ["all", "processing", "solved", "cancelled"];

  useEffect(() => {
    if (focused && !isFirstLoad) {
      setEndReached(false);
      fetchAllTickets({ limit: 3, filter: statusListEn[selectedIndex] });
    } else if (!focused) {
      setShowDropDown(false);
    }
  }, [Boolean(focused)]);

  useEffect(() => {
    if (fetching) {
      fetchAllTickets({ limit: 3, filter: statusListEn[selectedIndex] });
    }
  }, [selectedIndex, fetching]);

  useEffect(() => {
    if (navigation && typeof navigation.setParams === "function") {
      navigation.setParams({
        headerTitle: t(`${PATH}/allTickets`),
        numberOfLines: 2,
        headerStyle: { width: "80%" },
      });
      navigation.setOptions({
        headerRight: () =>
          showDropDown ? null : (
            <TouchableOpacity
              onPress={() => {
                setShowDropDown(true);
              }}
            >
              <Text variant="body_text_2" style={styles.filterText}>
                {t(`${PATH}/filter`)}
              </Text>
            </TouchableOpacity>
          ),
        IsRightIconDropDown: () => {
          {
            return showDropDown ? (
              <View style={styles.rightIconDropdownView}>
                <Pressable>
                  <View>
                    {
                      <View style={styles.dropdownView}>
                        {statusList?.map((val, index) => (
                          <TouchableOpacity
                            onPressIn={() => onPressStatus(index)}
                          >
                            <Text
                              style={{
                                color:
                                  index === selectedIndex
                                    ? colors.primary
                                    : colors.mediumBlack,
                                paddingVertical: 10,
                                fontSize: 14,
                                fontFamily:
                                  index === selectedIndex
                                    ? fontFamily.semiBold
                                    : fontFamily.regular,
                              }}
                            >
                              {val}
                            </Text>
                          </TouchableOpacity>
                        ))}
                      </View>
                    }
                  </View>
                </Pressable>
              </View>
            ) : null;
          }
        },
      });
    }
  }, [showDropDown]);

  const fetchAllTickets = async ({
    limit = 10,
    offset = 0,
    filter = "all",
  }) => {
    // setFetching(true);
    setEndReached(false);
    try {
      const {
        data: {
          list,
          totalCount: { count },
        },
      } = await fetchOpenTicketsNew({
        limit,
        offset,
        filter,
      });
      setTotalTicketCount(count);
      setTickets(list);
      setFetching(false);
      setIsFirstLoad(false);
    } catch (e) {
      console.log(e);
    }
  };

  const onPressStatus = (index) => {
    setSelectedIndex(index);
    setShowDropDown(false);
    setFetching(true);
    if (
      scrollRef &&
      scrollRef.current &&
      typeof scrollRef.current.scrollToIndex === "function"
    ) {
      scrollRef.current.scrollToIndex({
        animated: true,
        index,
        viewOffset: 15,
      });
    }
  };

  const loadmore = (status) => {
    if (tickets.length < Number(totalTicketCount) && !endReached) {
      // do load more
      setFetchMore(true);
      (async function () {
        try {
          const {
            data: {
              list,
              totalCount: { count },
            },
          } = await fetchOpenTicketsNew({
            limit: 3,
            offset: tickets.length,
            filter: status,
          });
          if (list.length) setTickets([...tickets, ...list]);
          if (list.length == 0) {
            setEndReached(true);
          }
          setFetchMore(false);
        } catch (e) {
          console.log(e);
        }
      })();
    } else {
      setEndReached(true);
    }
  };

  if (fetching) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      {showCancelModal && (
        <CancelOrReopenDialog
          visible={showCancelModal}
          title="कैंसिल टिकट "
          message="क्या आप अपना टिकट कैंसिल करना चाहते हैं |"
          buttons={[
            {
              text: "नहीं ",
              onPress: () => setShowCancelModal(false),
              style: "cancel",
            },
            {
              text: "हाँ ",
              onPress: () => {
                cancelSupportTicket(cancelTicketid, issueLevel1, async () => {
                  setShowCancelModal(false);
                  // reload the list...
                  setFetching(true);
                });
              },
              style: "okay",
            },
          ]}
        />
      )}
      <View style={{ marginTop: 10, flex: 1 }}>
        <TicketsList
          tickets={tickets}
          statusEn={statusListEn[selectedIndex]}
          statusHi={statusList[selectedIndex]}
          handleReloadList={() => setFetching(true)}
          loadmore={loadmore}
          fetchMore={fetchMore}
          onCancelTicket={(id, issue_level_1) => {
            // do cancel and other things here.
            setCancelTicketId(id);
            setIssueLevel1(issue_level_1);
            setShowCancelModal(true);
          }}
        />
      </View>
    </>
  );
};

export default AllTickets;

const styles = StyleSheet.create({
  rightIconDropdownView: {
    position: "absolute",
    right: 0,
    minWidth: 40,
    height: "100%",
    top: 20,
    backgroundColor: colors.white,
  },
  dropdownView: {
    zIndex: 500,
    position: "relative",
    marginRight: 16,
    minWidth: 140,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,
    elevation: 3,
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: colors.white,
  },
  filterText: {
    color: colors.primary,
    marginTop: 7,
  },
});
